<template>
  <div :class="[$style.wrapper]">
    <div
      :class="[
        $style.wrapper__body,
        {
          [$style['wrapper__body--wide']]: wide,
        },
      ]"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    fullBleed?: boolean
    wide?: boolean
  }>(),
  {
    fullBleed: false,
    wide: false,
  }
)
</script>

<style lang="scss" module>
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;

  &__body {
    --content-width: #{$content-width};

    width: 100%;
    box-sizing: content-box;
    max-width: var(--content-width);

    &--wide {
      --content-width: #{$content-width + 240px};
    }
  }
}
</style>
